/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getChatMessage = /* GraphQL */ `
  query GetChatMessage($id: ID!) {
    getChatMessage(id: $id) {
      id
      content
      author
      roomId
      createdAt
      updatedAt
    }
  }
`;

export const listChatMessagesByRoom = `
query MyQuery($eq: String) {
  listChatMessages(filter: {roomId: {eq: $eq}}) {
    nextToken
    items{
      id
      roomId
      author
      content
      createdAt
      updatedAt
    }
  }
}

`;

export const listChatMessagesByRoomWithNextToken = `
query MyQuery($nextToken: String,$eq: String) {
  listChatMessages(nextToken: $nextToken,filter: {roomId: {eq: $eq}}) {
    nextToken
    items{
      id
      roomId
      author
      content
      createdAt
      updatedAt
    }
  }
}

`;

export const listChatMessages = /* GraphQL */ `
  query ListChatMessages(
    $filter: ModelChatMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChatMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        content
        author
        roomId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
